import React from 'react';
import { getGame } from '../GameContent';

import GameData from '../Components/GameData';
import GamePresentation from '../Components/GamePresentation';

//mise en page marine
const styles = {
  page: { maxWidth: 860, margin: '40px auto', padding: '0 16px', lineHeight: 1.7, fontSize: 16 },
  switchBar: {
    display: 'flex', justifyContent: 'center', gap: 12,
    padding: '10px 14px', background: '#f6f7f9',
    border: '1px solid #e5e7eb', borderRadius: 12, marginBottom: 24
  },
  linkPill: {
    display: 'inline-block', padding: '8px 14px', borderRadius: 9999,
    border: '1px solid #d1d5db', textDecoration: 'none', color: '#111827'
  },
  h1: { fontSize: 28, lineHeight: 1.25, margin: '0 0 8px 0' },
  meta: { fontSize: 13, color: '#6b7280', margin: '0 0 24px 0' },
  h2: { fontSize: 20, margin: '28px 0 8px 0' },
  ul: { paddingLeft: 22, margin: '8px 0 16px 0' },
};
//fin

const game = [];

class EulaPage extends React.Component {
  state = {
    game
  }

  async componentDidMount() {

    const game = [await getGame()];

    this.setState({ game })
  }

  render() {
    const { game } = this.state

    if (game[0] !== undefined) {
      const gamedata = game[0];
      return (
        <div style={styles.page}>
          {/* Barre de switch / lien sous l'en-tete */}
          <div style={styles.switchBar} role="navigation" aria-label="Legal pages">
            <a href="/eula" style={styles.linkPill}>End-user license agreement</a>
            <a href="/policy" style={styles.linkPill}>Privacy policy</a>
          </div>

          <h1 style={styles.h1}>END USER LICENSE AGREEMENT (EULA)</h1>
          <p style={styles.meta}><strong><em>Last updated: January 22, 2026</em></strong></p>
          <p><strong>{gamedata.name}<br />Piece of Cake Studios, S.A.S.</strong></p>

          <h2 style={styles.h2}>IMPORTANT NOTICE</h2>
          <p>
            {gamedata.name} is a horror game and may contain frightening content, intense atmosphere, and audiovisual effects.
            Please use discretion and take breaks if you feel discomfort.
          </p>
          <p>
  		    You must be at least the minimum age required by applicable law in your country of residence and, where applicable,
		    the minimum age indicated by the applicable age rating to access and use the Game. If you are under the age of majority
		    where you live, you must have permission from a parent or legal guardian.
		  </p>

          <h2 style={styles.h2}>1. Agreement and acceptance</h2>
          <p>
            This End User License Agreement ("EULA") is a legal agreement between you ("you") and Piece of Cake Studios, S.A.S.
            (8 rue Martel, 75010 Paris, France; Paris RCS No. 814368809) ("Piece of Cake", "we", "us") governing your
            access to and use of {gamedata.name}, including any updates, patches, and related online features (the "Game").
          </p>
          <p>
            BY DOWNLOADING, INSTALLING, ACCESSING, OR PLAYING THE GAME, YOU AGREE TO THIS EULA. IF YOU DO NOT AGREE, DO NOT USE THE GAME.
          </p>

          <h2 style={styles.h2}>2. Platform terms and third-party services</h2>
          <p>
            If you access the Game through a third-party platform or store (for example Steam, Epic Games Store, PlayStation, or Xbox),
            your use of the Game is also subject to that platform's terms, policies, and code of conduct, which may include additional rules
            for online play and communications. In case of conflict, mandatory platform requirements prevail for that platform.
          </p>
          <p>
            Online play may rely on platform network services. Access to and use of PlayStation Network (PSN) and Xbox services is conditioned
            on acceptance of their respective terms.
          </p>

          <h2 style={styles.h2}>3. License grant</h2>
          <p>
            <strong>3.1 License.</strong> We grant you a limited, personal, non-exclusive, non-transferable, revocable license to install and use the Game
            for personal, non-commercial entertainment purposes, subject to this EULA and applicable platform terms.
          </p>
          <p>
            <strong>3.2 Updates.</strong> The Game may update automatically or require updates to continue working online. Updates may modify or remove features.
          </p>

          <h2 style={styles.h2}>4. Restrictions</h2>
          <p>You may not (except where applicable law permits despite this restriction):</p>
          <ul style={styles.ul}>
            <li>Copy, distribute, sell, rent, lease, sublicense, or commercially exploit the Game.</li>
            <li>Modify, adapt, translate, or create derivative works based on the Game.</li>
            <li>Reverse engineer, decompile, disassemble, or attempt to access the source code.</li>
            <li>Circumvent security or anti-cheat measures, use cheats, bots, automation, exploits, or any method that gives an unfair advantage or disrupts the Game.</li>
            <li>Use the Game to harass, threaten, defame, or harm others, or to collect/disclose personal information of other players.</li>
          </ul>

          <h2 style={styles.h2}>5. Ownership and intellectual property</h2>
          <p>
            The Game and all related intellectual property rights (including code, graphics, music, characters, story, and trademarks) are owned by Piece of Cake and/or its licensors.
            You receive a license to use the Game; you do not own it.
          </p>

          <h2 style={styles.h2}>6. Online features, cross-play, and availability</h2>
          <p>
            <strong>6.1 Online features.</strong> The Game includes online multiplayer features and may support cross-play between platforms.
            Online features may require an internet connection and an active platform account.
          </p>
          <p>
            <strong>6.2 No guarantee of availability.</strong> We do not guarantee that online services, matchmaking, cross-play, or any online feature will be available at all times or indefinitely.
            We may change, suspend, or discontinue online features for technical, security, legal, or business reasons, consistent with applicable law.
          </p>

          <h2 style={styles.h2}>7. Communications (voice chat) and player conduct</h2>
          <p>
            <strong>7.1 Voice chat.</strong> The Game may include voice communications. There is no in-game text chat feature.
          </p>
          <p><strong>7.2 Rules of conduct.</strong> You must behave respectfully and use common sense when interacting with others. Examples of prohibited conduct include:</p>
          <ul style={styles.ul}>
            <li>Hate speech, harassment, threats, or abusive behavior.</li>
            <li>Defamation, stalking, or encouraging harm to others.</li>
            <li>Sharing personal information of other players (doxxing).</li>
            <li>Using voice chat to spam, disrupt, or impair other players' experience.</li>
          </ul>
          <p>
            <strong>7.3 Enforcement.</strong> We may take reasonable actions to enforce this EULA and protect players and the integrity of the Game,
            including warnings, temporary suspensions, or permanent bans from online features, subject to applicable law and platform requirements.
          </p>

          <h2 style={styles.h2}>8. No user-generated content (UGC)</h2>
          <p>
            The Game does not provide user-generated content publishing tools (for example: sharing custom levels, uploading content, or public text postings).
            If this changes in the future, additional terms may apply.
          </p>

          <h2 style={styles.h2}>9. Privacy</h2>
          <p>
            Our processing of information related to the Game is described in the {gamedata.name} Privacy Policy, which is incorporated by reference.
            Platform providers also process data under their own privacy policies.
          </p>

          <h2 style={styles.h2}>10. Purchases and refunds</h2>
          <p>
            Purchases (if any) are processed by the platform store (for example Steam, Epic, PlayStation Store, Microsoft Store).
            We do not receive your full payment details from the platform. Refunds are handled according to the platform's refund policies and applicable law.
          </p>

          <h2 style={styles.h2}>11. Disclaimer of warranties</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE GAME IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED.
            SOME JURISDICTIONS DO NOT ALLOW CERTAIN DISCLAIMERS; IN THAT CASE, THOSE DISCLAIMERS DO NOT APPLY TO YOU.
          </p>

          <h2 style={styles.h2}>12. Limitation of liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, PIECE OF CAKE WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
            OR FOR LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL, ARISING OUT OF OR RELATED TO YOUR USE OF THE GAME.
          </p>
          <p>
            NOTHING IN THIS EULA LIMITS LIABILITY THAT CANNOT BE EXCLUDED UNDER APPLICABLE LAW (INCLUDING CERTAIN CONSUMER RIGHTS).
          </p>

          <h2 style={styles.h2}>13. Termination</h2>
          <p><strong>13.1 Termination by you.</strong> You may stop using the Game at any time.</p>
          <p><strong>13.2 Termination/suspension by us.</strong> We may suspend or terminate your access to the Game and/or online features if you breach this EULA or applicable platform rules.</p>
          <p>
			  Upon termination, you must stop using the Game and delete or uninstall the Game from your devices, to the extent permitted
			  by applicable platform rules.
			</p>

          <h2 style={styles.h2}>14. Changes to this EULA</h2>
          <p>
            We may update this EULA from time to time. If changes are material, we will provide notice through the Game, our website,
            or the relevant store listing, and the updated EULA will apply from the effective date stated in that notice.
            If you do not agree, you must stop using the Game.
          </p>

          <h2 style={styles.h2}>15. Governing law</h2>
          <p>
            This EULA is governed by the laws of France. If you are a consumer in the EEA/UK, you may also benefit from mandatory consumer protection laws
            of your country of residence.
          </p>

          <h2 style={styles.h2}>16. Contact</h2>
          <p>
            Questions about this EULA: <a href="mailto:contact@pieceofcake-studios.com">contact@pieceofcake-studios.com</a>
          </p>

        </div>
      );

    } else {
      return (
        <div>
          Game not found. There was a problem with the database.
        </div>
      );
    }
  }
}

export default EulaPage;
